import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { Clickable } from '@moda/om';
import ExitIcon from '@moda/icons/exit-20';
import SortIcon from '@moda/icons/sort-16';
import { SortOption } from '../../constants';
import { ModalOverlay } from '../Modal';

import './ProductListingMobile.scss';

type ProductListingMobileSortProps = {
  availableSorts: SortOption[];
  currentSort: SortOption;
  onSortChanged: (sort: SortOption['value']) => void;
};

export const ProductListingMobileSort: React.FC<ProductListingMobileSortProps> = ({
  availableSorts,
  currentSort,
  onSortChanged
}) => {
  const [sortOpen, setSortOpen] = useState(false);
  const closeSort = useCallback(() => setSortOpen(false), []);
  const openSort = useCallback(() => setSortOpen(true), []);
  const handleClickSort = useCallback(
    sort => {
      onSortChanged(sort.value);
      setSortOpen(false);
    },
    [onSortChanged]
  );

  return (
    <>
      <Clickable className="ProductListingMobile__action" onClick={openSort}>
        <span className="ProductListingMobile__actionText">Sort</span>
        <SortIcon className="ProductListingMobile__actionIcon" />
      </Clickable>

      {sortOpen && (
        <ModalOverlay className="ProductListingMobile__modal" onClose={closeSort}>
          <div className="ProductListingMobile__panelSort">
            <Clickable className="ProductListingMobile__panelClose" onClick={closeSort}>
              <ExitIcon />
            </Clickable>
            <div className="ProductListingMobile__panelTitle">Sort By</div>
            {availableSorts.map(sort => (
              <Clickable
                className={classnames('ProductListingMobile__sortName', {
                  'ProductListingMobile__sortName--active': currentSort.value === sort.value
                })}
                key={sort.value}
                onClick={() => handleClickSort(sort)}
              >
                {sort.name}
              </Clickable>
            ))}
          </div>
        </ModalOverlay>
      )}
    </>
  );
};
